import { render } from "./ModalFormPosition.vue?vue&type=template&id=0410df0d&scoped=true"
import script from "./ModalFormPosition.vue?vue&type=script&lang=js"
export * from "./ModalFormPosition.vue?vue&type=script&lang=js"

import "./ModalFormPosition.vue?vue&type=style&index=0&id=0410df0d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0410df0d"]])

export default __exports__